const initialState = {
  donation: { touched: false },
  portfolio: { touched: false },
};

const drawerReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_OPEN_DRAWER': {
      const { drawer, touched } = action.payload;
      const newState = {...state};
      newState[drawer].touched = touched;
      return newState;
    }
    default: {
      return state;
    }
  }
};

export default drawerReducer;
